// public/js/features/alerts/push-client.js
// Registers the service worker and subscribes to Web Push so alerts reach the
// phone even when the browser/tab is closed (where the platform supports it:
// Android/desktop Chrome, Firefox; iOS only when installed as a PWA).

export function pushSupported() {
  return ('serviceWorker' in navigator) && ('PushManager' in window) && ('Notification' in window);
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

let _reg = null;
async function getRegistration() {
  if (_reg) return _reg;
  _reg = await navigator.serviceWorker.register('/sw.js');
  await navigator.serviceWorker.ready;
  navigator.serviceWorker.addEventListener('message', (e) => {
    if (e.data && e.data.type === 'open-alerts') window.location.hash = '#alerts';
  });
  return _reg;
}

export async function enablePush() {
  if (!pushSupported()) return { ok: false, reason: 'unsupported' };
  if (Notification.permission !== 'granted') {
    const p = await Notification.requestPermission();
    if (p !== 'granted') return { ok: false, reason: 'denied' };
  }
  try {
    const reg = await getRegistration();
    const { publicKey } = await (await window.authenticatedFetch('api/v1/push/vapid-key')).json();
    if (!publicKey) return { ok: false, reason: 'no-vapid' };

    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      });
    }
    const j = sub.toJSON();
    await window.authenticatedFetch('api/v1/push/subscribe', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ subscription: { endpoint: j.endpoint, keys: j.keys } }),
    });
    return { ok: true };
  } catch (e) {
    console.warn('[push] enable failed', e);
    return { ok: false, reason: e.message };
  }
}
